import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { configureExperience } from './lib/experience';
import { restoreUiLocale } from './lib/i18n';
import { restoreAppTheme } from './lib/theme';
import { restoreSettings } from './lib/settings';
import './styles.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('UTAGE root element is missing.');
}

restoreUiLocale();
restoreAppTheme();
restoreSettings();
configureExperience();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
